import React from 'react';
import reqwest from 'reqwest';
import ReactTable from 'react-table';

import settings from '../../../../../../settings';
import sortByDate from '../../../../../logic/sortByDate';

import RightSide from '../../../../../components/FormArea/RightSide';
import Loader from '../../../../../components/Loader';
import ContentBox from '../../../../../components/FormArea/ContentBox';
import Button from '../../../../../components/Button';
import { faPlus } from '@fortawesome/pro-solid-svg-icons';

class OpeningHoursOverview extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      openingHours: [],
      loading: true,
    };

    reqwest({
      method: 'get',
      url: settings.franchise.openingHours.getList,
      contentType: 'json',
      data: {
        Token: localStorage.getItem('token'),
        FranGuid: this.props.franchiseGuid,
      },
    }).then(openingHoursResponse => {
      const openingHours = JSON.parse(openingHoursResponse);
      this.setState({
        openingHours,
        loading: false,
      });
    });
  }

  render() {
    if (this.state.loading) {
      return <Loader />;
    }

    const data = this.state.openingHours.filter(row => row.Params.Guid);

    return (
      <>
        <div className='FormArea-Form-Left'>
          <ContentBox title='Öffnungszeiten'>
            <ReactTable
              getTrProps={(_, { original }) => ({
                onClick: () => this.props.history.replace(`${this.props.match.url}/${original.Params.Guid}`),
              })}
              data={data}
              pageSize={data.length}
              noDataText='Es liegen keine Öffnungszeiten für das ausgewählte Franchisebüro vor.'
              defaultSorted={[
                {
                  id: 'Params.Validfrom',
                  desc: true,
                },
              ]}
              columns={[
                {
                  Header: 'Titel',
                  accessor: 'Params.Title',
                },
                {
                  Header: 'Von',
                  accessor: 'Params.Validfrom',
                  sortMethod: sortByDate,
                },
                {
                  Header: 'Bis',
                  accessor: 'Params.Validto',
                  sortMethod: sortByDate,
                },
              ]}
            />
          </ContentBox>
        </div>
        <RightSide>
          <Button big icon={faPlus} to={`${this.props.match.url}/new`} replace>
            Neue Öffnungszeiten
          </Button>
        </RightSide>
      </>
    );
  }
}

export default OpeningHoursOverview;
